import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { createApplicationAction } from "../../../../redux/actions/ApplicationAction";
import notify from "../../../../Notifcation";
import { useNavigate } from "react-router-dom";
import { GetAllTouristTypeAction } from "../../../../redux/actions/TouristAction";
import { countries } from "../../../COUNTRIES.";

const Recdence = () => {
  const [Miltary, setMiltary] = useState("");
  const [Picuser, setPicuser] = useState("");
  const [Typehum, setTypehum] = useState("");

  const [Passpor, setPasspor] = useState([]);
  const [Nationalid, setNationalid] = useState("");
  const [TypetouristID, setTypetouristID] = useState("");
  const [Category, setCategory] = useState("");
  const navegate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const AllTour = useSelector(
    (state) => state.TouristReduser.GetallTouristType
  );
  useEffect(() => {
    dispatch(GetAllTouristTypeAction(`type=residence`));
  }, []);
  useEffect(() => {
    if (TypetouristID !== "") {
      dispatch(
        GetAllTouristTypeAction(`type=residence&location=${TypetouristID&&TypetouristID.name?TypetouristID.name:""}`)
      );
    }
  }, [TypetouristID]);
  const handleFileChangePasspor = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setPasspor(files);
  };
  const handleFileChangePicuser = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setPicuser(files);
  };

  const handlesubmitEmp = async (e) => {
    e.preventDefault();
    if (
      Typehum === "M"
        ? Miltary === ""
        : null ||
          Picuser === "" ||
          TypetouristID === "" ||
          Passpor === "" ||
          Category === "" ||
          // Location === "" ||
          Nationalid === "" ||
          Typehum === ""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("application_type", 4);
    formData.append("tourist_application_type_id", Category);
    formData.append("military_service", Miltary);
    formData.append("client_national_id", Nationalid);
    Passpor.map((item) => {
      return formData.append("passports", item);
    });
    Picuser.map((item) => {
      return formData.append("client_images", item);
    });
    await dispatch(createApplicationAction(formData));
    setLoading(false);
    setisPress(false);
    setCategory("");
    setTypetouristID("");
    setNationalid("");
  };
  const res = useSelector((state) => state.ApplicationReduser.createApp);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            setTimeout(() => {
              navegate("/user/requestsuser");
            }, 3000);
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <Container>
      {" "}
      <h3 className="text-center mb-3 mt-3">حجز الأقامة </h3>
      <div className="inputs-container">
        <div className="inp-container ">
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            value={TypetouristID}
            options={countries && countries.length >= 0 ? countries : []}
            sx={{ width: 300 }}
            onChange={(e, v) => setTypetouristID(v)}
            getOptionLabel={(option) => {
              // Value selected with enter, right from the input
              if (typeof option === "string") {
                return option;
              }
              // Add "xxx" option created dynamically
              if (option.inputValue) {
                return option.inputValue;
              }
              // Regular option
              return option.name;
            }}
            // renderOption={(props, option) => (
            //   <li {...props} key={option.id}>
            //     {option.name}
            //   </li>
            // )}
            renderInput={(params) => (
              <TextField
                {...params}
                label={
                  <Typography>
                    الدولة
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
              />
            )}
          />
        </div>
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              <Typography>
                المدة
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  المدة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={Category}
              onChange={(e) => setCategory(e.target.value)}
            >
              {AllTour && AllTour.length > 0
                ? AllTour.map((item, idx) => (
                    <MenuItem value={item.id}>{item.category}</MenuItem>
                  ))
                : null}
            </Select>
          </FormControl>
        </div>
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  النوع
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  النوع
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={Typehum}
              onChange={(e) => setTypehum(e.target.value)}
            >
              <MenuItem value={"M"}>ذكر</MenuItem>
              <MenuItem value={"F"}>انثى</MenuItem>
            </Select>
          </FormControl>
        </div>
        {Typehum === "M" ? (
          <div className="inp-container ">
            <TextField
              label={
                <Typography>
                  شهادة الخدمة العسكرية
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              focused
              type="file"
              onChange={(e) => {
                setMiltary(e.target.files[0]);
              }}
              variant="outlined"
            />
          </div>
        ) : Typehum === "F" ? (
          <></>
        ) : null}
        <div className="inp-container ">
          <TextField
            label={
              <Typography>
                البطاقة الشخصية
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            focused
            type="file"
            onChange={(e) => {
              setNationalid(e.target.files[0]);
            }}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={
              <Typography>
                جواز السفر
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangePasspor}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={
              <Typography>
                الصورة الشخصية
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangePicuser}
            variant="outlined"
          />
        </div>

        <div className="inp-container "></div>
        <div className="inp-container "></div>
      </div>
      {isPress && loading ? (
        <button className="buttonadd">
          <Spinner />
        </button>
      ) : (
        <button className="buttonadd" onClick={handlesubmitEmp}>
          {" "}
          استكمال الطلب
        </button>
      )}
      <ToastContainer />
    </Container>
  );
};

export default Recdence;
